/**
 * VistaPermalinkRig — Canvas-scope host for the useVistaPermalink hook.
 *
 * Plan 07-06 Task 1 (HOST-04). The hook uses useThree() + useFrame() which
 * only resolve inside the R3F Canvas. This component is the standard mount
 * point; it renders nothing.
 *
 * Mount in SceneGraph (inside the <Canvas>) alongside other side-effect-only
 * rigs like VistaGate, AudioListenerBinding, and DrawCallProbe.
 */
import { useVistaPermalink } from './useVistaPermalink';

export function VistaPermalinkRig() {
  useVistaPermalink();
  return null;
}
